module.exports = __webpack_public_path__ + "static/media/eva3.e7bbf1be.png";